export default "__VITE_ASSET__CnGRQDrR__"